import { CSSProperties } from "react";
import SmallSpinner from "@components/ui/loading/SmallSpinner";

interface ButtonProps {
  label?: string;
  onClick?: () => void;
  style?: CSSProperties;
  variant?: "small" | "medium" | "large";
  type?: "submit" | "button";
  disabled?: boolean;
  loading?: boolean;
  children?: React.ReactNode | string | null;
  className?: string;
  startIcon?: React.ReactNode;
  id?: string;
}

export default function Button({
  label,
  onClick,
  style,
  variant = "medium",
  type = "button",
  disabled = false,
  loading = false,
  children,
  startIcon,
  className,
  id,
}: ButtonProps) {
  const isDisabled = disabled || loading;
  return (
    <button
      id={id}
      type={type}
      className={`
        ${variant === "small" ? "w-fit px-4 py-2 rounded-lg font-medium text-h2" : variant === "medium" ? "w-fit px-6 py-3 rounded-xl shadow-md font-medium text-h2" : "  w-full px-6 py-3 font-semibold rounded-xl"}
          ${isDisabled ? "bg-neutral-300 text-neutral-500 cursor-not-allowed" : "bg-black text-white cursor-pointer"}

    ${(startIcon || loading) && " flex-row flex items-center"}
           hover:ring-2 hover:ring-neutral-300  h-fit ${className} `}
      onClick={onClick}
      disabled={isDisabled}
    >
      {loading ? (
        <SmallSpinner size={18} margin={4} />
      ) : startIcon ? (
        <div className="mr-2 flex flex-row items-center">{startIcon}</div>
      ) : null}
      {label || children}
    </button>
  );
}
